// Serviço para métricas do dashboard da clínica
import api from './api';


export const getMetricasClinica = async (mes, ano) => {
  const params = {};
  if (mes) params.mes = mes;
  if (ano) params.ano = ano;
  try {
    const response = await api.get('clinica/metricas', { params });
    console.log('Resposta da API clinica/metricas:', response);
    return response;
  } catch (error) {
    console.error('Erro ao buscar métricas da clínica:', error);
    if (error.response) {
      return error.response;
    }
    return { success: false, message: 'Erro de conexão com backend', data: null };
  }
};
